import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "@/services/axiosAuth";
import { OWNER_ACCOUNT_DETAILS_API } from "../apiRoutes";

const mutateUpdateOwnerAccountDtl = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${OWNER_ACCOUNT_DETAILS_API}/${id}`, data);
};

const useUpdateOwnerAccountDtlMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateOwnerAccountDtl,
    ...queryParams,
  });

export default useUpdateOwnerAccountDtlMutation;
